import type {
  AlertItem,
  EventItem,
  FooterInfo,
  HeroContent,
  LinkGroup,
  Notice,
  QuickLink,
} from '../types/content'

/** Pictures taken from the Town's own site. */
const IMG_PUBLIC_WORKS = 'https://town.bonnyville.ab.ca/wp-content/uploads/2024/09/Public-Works-400x250.png'
const IMG_TOWN_HALL = 'https://town.bonnyville.ab.ca/wp-content/uploads/2024/08/Town-Hall-Notice-400x250.png'
const IMG_POOL = 'https://town.bonnyville.ab.ca/wp-content/uploads/2024/08/Pool-Notice-400x250.png'
const IMG_PARK = 'https://town.bonnyville.ab.ca/wp-content/uploads/2024/07/Park2.jpg'
const IMG_TOWN = 'https://town.bonnyville.ab.ca/wp-content/uploads/2024/07/town10.jpg'

export const hero: HeroContent = {
  eyebrow: 'Town of Bonnyville',
  title: 'A place that becomes a part of you.',
  body: [
    'Welcome to the Town of Bonnyville, a vibrant community nestled in the heart of Alberta’s Lakeland region. Discover our rich history, breathtaking natural beauty, and endless opportunities for outdoor adventure.',
    'Whether you’re seeking relaxation or excitement, Bonnyville has something to offer everyone. Explore our charming downtown, home to unique shops and delicious local cuisine. Immerse yourself in our thriving arts and culture scene, with year-round events and festivals celebrating our diverse community. Plan your visit today and experience the warmth and hospitality of Bonnyville for yourself.',
  ],
  cta: 'Learn More',
  image: IMG_PARK,
}

/** The bciti+ service bar: the one row of modules added under the hero. */
export const quickLinks: QuickLink[] = [
  { label: 'My Dashboard', icon: 'smartphone', to: '/my-dashboard' },
  { label: 'Registration and bookings', icon: 'ball', to: '/my-recreation' },
  { label: 'Requests and reports', icon: 'alert', to: '/my-requests' },
  { label: 'Collections', icon: 'trash', to: '/my-collections' },
  { label: 'Pet licences', icon: 'pet', to: '/my-pets' },
  { label: 'Permit application', icon: 'permit' },
  { label: 'Public notices', icon: 'bell', to: '/notifications' },
]

export const heroPrompts: { label: string; to: string }[] = [
  { label: 'My next collection', to: '/my-collections' },
  { label: 'Report a problem', to: '/my-requests' },
  { label: 'Register my child', to: '/my-recreation' },
]

export const alert: AlertItem = {
  level: 'info',
  title: 'Notice of road closure — 50 Avenue (Main Street)',
  detail: 'Paving work continues until September 13.',
  body: [
    'Paving repairs close 50 Avenue between 48 and 50 Street from September 10 to 13, 2026.',
    'Access to downtown businesses and homes is maintained on foot. Please follow the signed detour and expect delays through the core.',
  ],
  scope: '50 Avenue between 48 and 50 Street · September 10 to 13, 2026',
}

export const notices: Notice[] = [
  {
    id: 'road-closure',
    caption: 'Public Works',
    tag: 'News',
    date: 'Sep 8, 2026',
    title: 'Notice of Road Closure: 50 Ave. (Main Street) – September 10-13',
    image: IMG_PUBLIC_WORKS,
  },
  {
    id: 'pool-closure',
    caption: 'Swimming Pool',
    tag: 'News',
    date: 'Sep 8, 2026',
    title: 'Annual Pool Closure Now Underway',
    image: IMG_POOL,
  },
  {
    id: 'back-to-school',
    caption: 'Town Hall',
    tag: 'News',
    date: 'Sep 2, 2026',
    title: 'Back-to-school reminder: Help keep school drop-off areas safe',
    image: IMG_TOWN_HALL,
  },
]

/** Photo shown beside the Local Notices band. */
export const noticesImage = IMG_TOWN

export const events: EventItem[] = [
  {
    id: 'date-night',
    day: '11',
    month: 'SEP',
    time: '5:30 pm - 7:30 pm',
    title: 'Date Night in the Park with Clayton Bellamy',
  },
  {
    id: 'strays',
    day: '3',
    month: 'OCT',
    time: '6:00 pm - 9:00 pm',
    title: 'Stand Up for Strays Comedy Night Returns to Bonnyville',
  },
]

export const quickAccess: LinkGroup[] = [
  {
    title: 'Municipal Election',
    links: [
      'General Municipal Election',
      'Candidate Information',
      'Registered Candidates',
      'Municipal Voter Information',
    ],
  },
  {
    title: 'Documents',
    links: [
      'Town Policies',
      'Town Bylaws',
      'Permit Applications',
      'Planning & Development',
      'Department Directory',
    ],
  },
  {
    title: 'History',
    links: ['About Bonnyville', 'Bonnyville’s History'],
  },
  {
    title: 'Resources',
    links: [
      'Tenders & RFP Information',
      'Neighbouring Communities',
      'Alberta Fire Bans',
      'Wild Fires Alberta',
      'Emergency Preparedness',
      'Town Mobile App Site',
    ],
  },
  {
    title: 'Quicklinks',
    links: [
      'RCMP Crime Map',
      'Town Maps',
      'Landfill Hours',
      'Garbage Pick-Up Schedule',
      'Swimming Pool',
      'Snow Removal Map',
    ],
  },
]

export const footerInfo: FooterInfo = {
  name: 'Town of Bonnyville',
  address: ['4917 – 49 Avenue Bag 1006', 'Bonnyville AB T9N 2J7'],
  inquiryEmail: 'admin@town.bonnyville.ab.ca',
  paymentEmail: 'epayment@town.bonnyville.ab.ca',
  tollFree: '1-866-826-3496',
  phone: '1-780-826-3496',
  hours: ['Monday to Friday 8:30 a.m. to 4:30 p.m.', 'Closed for statutory holidays'],
  regional: ['MD of Bonnyville', 'City of Cold Lake', 'Alberta Hub'],
  poweredBy: 'AB Web Services',
}
